<template>
  <v-layout></v-layout>
</template>
<script>
import StoryForm from './StoryForm';
export default {
  name: 'VideoForm',
  extends: StoryForm
};
</script>



// WEBPACK FOOTER //
// VideoForm.vue?7f030ce1